import { useState, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form"
import InputMask from "react-input-mask";
import styles from "../Cadastro.module.css";
import { FormControl, InputLabel, Container } from "@mui/material";
import { UF, OpcoesUF } from "../../../../components/Combobox/UF";
import { HelperText } from "../../../../components/Errors/HelperText";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import Maps from "../../../../components/Maps/Maps";
import servParam from "../../../../services/login/servParam";
import { BlueHoverButton } from "../../../../components/Inputs/BlueHoverButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import { faExpand, faCompass, faArrowRightArrowLeft, faCompress, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { EnumStatusChaveApiGoogle } from "../../../../infra/utils/Enums";

import axios from "axios";

const Localizacao = ({ setIsLoading, setOpenError, setErrorMessage, situacaoSolic, codigoUc, onKeyDown, unidadeConsumidora, podeSalvar }) => {
    const { control, getValues, setValue, formState: { errors } } = useFormContext();
    const [disponibilizaMapa, setDisponibilizaMapa] = useState(0);
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
    const [chaveApiGoogle, setChaveApiGoogle] = useState("");
    const [hiddenEnderecos, setHiddenEnderecos] = useState(false);
    const [coordenadaSalva, setCoordenadaSalva] = useState(null);
    const [updateKey, setUpdateKey] = useState(0);

    const [hiddenCamposNaoAutorizados, setHiddenCamposNaoAutorizados] = useState(true);

    const editavel = situacaoSolic === 0 || situacaoSolic === 5 ? true : false;

    useEffect(() => {
        recuperarParametros();

        if (getValues("Latitude") && getValues("Longitude")) {
            setCoordenadaSalva({ lat: getValues("Latitude"), lng: getValues("Longitude") });
        } else {
            setCoordenadaSalva(null);
        }
    }, []);

    useEffect(() => {
        validarChaveApi(chaveApiGoogle);
    }, [chaveApiGoogle]);

    const onClickSetEndereco = async () => {
        try {
            const { lat, lng } = coordinates;
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${chaveApiGoogle}`;
            const response = await axios.get(url);
            const dados = response.data;

            if (dados.status === 'OK') {
                const resultado = dados.results[0];
                const componentes = resultado.address_components;

                const endereco = {
                    cidade: componentes.find(c => c.types.includes('administrative_area_level_2'))?.long_name,
                    bairro: componentes.find(c => c.types.includes('sublocality'))?.long_name,
                    rua: componentes.find(c => c.types.includes('route'))?.long_name,
                    numero: componentes.find(c => c.types.includes('street_number'))?.long_name,
                    cep: componentes.find(c => c.types.includes('postal_code'))?.long_name,
                    uf: componentes.find(c => c.types.includes('administrative_area_level_1'))?.short_name
                };

                setValue("Cidade", endereco.cidade || "");
                setValue("Endereco", endereco.bairro || "");
                setValue("Rua", endereco.rua || "");
                setValue("NumeroEnd", endereco.numero || 0);
                setValue("Cep", endereco.cep || "");
                setValue("UF", {
                    value: endereco.uf,
                    label: OpcoesUF.find((opcao) => opcao.value == endereco.uf).label
                });

                setValue("Latitude", lat);
                setValue("Longitude", lng);
            } else {
                console.error('Erro ao buscar dados:', dados.status);
            }
        } catch (erro) {
            console.error('Erro na requisição:', erro);
        }
    }

    const recuperarParametros = async () => {
        try {
            setIsLoading(true);
            const params = await servParam.recuperarGDParametros();

            setDisponibilizaMapa(params.Content.UsaMapas);
            setChaveApiGoogle(params.Content.ChaveGoogle);
            setIsLoading(false);

        } catch (err) {
            setIsLoading(false)
            console.log("erro" + err);
        }
    };

    const onChangeCoordinates = (coords) => {
        setCoordinates(coords);
    };

    const onClickSetCoordenadas = () => {
        setValue("Latitude", coordinates.lat);
        setValue("Longitude", coordinates.lng);
    };

    const onClickRetornarCoordenadas = () => {
        setCoordenadaSalva(null);
        setUpdateKey(prevKey => prevKey + 1);
    };

    const onClickSetFullscreenControl = () => {
        setHiddenEnderecos(prevState => !prevState);
    };

    const validarChaveApi = async (chaveApiGoogle) => {
        try {
            if (chaveApiGoogle) {
                const response = await servParam.validarChaveApi(chaveApiGoogle);

                if (response.Content?.Content === EnumStatusChaveApiGoogle.NAO_AUTORIZADO) {
                    setHiddenCamposNaoAutorizados(true);
                } else {
                    setHiddenCamposNaoAutorizados(false);
                }
            }
        } catch (err) {
            setIsLoading(false)
            console.log("erro" + err);
        }
    }

    return (
        <Container sx={{ mt: 2, display: "flex", alignItems: "center", width: "100%" }}>
            {Boolean(disponibilizaMapa) && (
                <div style={{ display: "flex" }}>
                    <Maps codigoUc={codigoUc} onChangeCoordinates={onChangeCoordinates} hiddenEnderecos={hiddenEnderecos} coordenadaSalva={coordenadaSalva} updateKey={updateKey} disabled={!podeSalvar} hiddenCamposNaoAutorizados={hiddenCamposNaoAutorizados} />
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", margin: hiddenCamposNaoAutorizados ? "45px 0px 0px 28px" : "120px 0px 0px 28px", height: "24vh" }}>
                        <Tooltip title={hiddenEnderecos ? "Recolher mapa" : "Expandir mapa"} arrow>
                            <BlueHoverButton style={{ color: "white", height: "40px" }} onClick={onClickSetFullscreenControl} disabled={!podeSalvar}>
                                <FontAwesomeIcon icon={!hiddenEnderecos ? faExpand : faCompress} style={{ color: !podeSalvar ? 'rgba(0, 0, 0, 0.26)' : "white" }} />
                            </BlueHoverButton>
                        </Tooltip>
                        {!hiddenCamposNaoAutorizados && (
                            <Tooltip title="Preencher dados de endereço conforme mapa" arrow >
                                <BlueHoverButton style={{ color: "white", height: "40px" }} onClick={onClickSetEndereco} disabled={!podeSalvar || !unidadeConsumidora}>
                                    <FontAwesomeIcon icon={faArrowRightArrowLeft} style={{ color: !podeSalvar || !unidadeConsumidora ? 'rgba(0, 0, 0, 0.26)' : "white" }} />
                                </BlueHoverButton>
                            </Tooltip>
                        )}
                        <Tooltip title="Preencher coordenadas conforme mapa" arrow >
                            <BlueHoverButton style={{ color: "white", height: "40px" }} onClick={onClickSetCoordenadas} disabled={!podeSalvar || !editavel}>
                                <FontAwesomeIcon icon={faCompass} style={{ color: !podeSalvar || !editavel ? 'rgba(0, 0, 0, 0.26)' : "white" }} />
                            </BlueHoverButton>
                        </Tooltip>
                        <Tooltip title="Retornar coordenadas da UC ou cidade padrão" arrow >
                            <BlueHoverButton style={{ color: "white", height: "40px" }} onClick={onClickRetornarCoordenadas} disabled={!podeSalvar || !editavel}>
                                <FontAwesomeIcon icon={faRotateLeft} style={{ color: !podeSalvar || !editavel ? 'rgba(0, 0, 0, 0.26)' : "white" }} />
                            </BlueHoverButton>
                        </Tooltip>
                    </div>
                </div>
            )}
            {!hiddenEnderecos && (
                <div style={{ width: "100%" }}>
                    <div className={styles['input-container']}>

                        <Controller
                            name="Cidade"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel htmlFor="solicitacao-Cidade" shrink sx={{ color: "#b8b8b8" }}>Cidade</InputLabel>
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Cidade"
                                        id="solicitacao-Cidade"
                                        name="Cidade"
                                        {...field}
                                        readOnly={!podeSalvar || !editavel || !unidadeConsumidora}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.Cidade ? styles.campoComValorErrado : ""}`}
                                    />
                                    {errors?.Cidade && (
                                        <HelperText text={errors?.Cidade?.message} />
                                    )}
                                </FormControl>
                            )}
                        />

                        <Controller
                            name="Endereco"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel htmlFor="solicitacao-endereco" shrink sx={{ color: "#b8b8b8" }}>Bairro</InputLabel>
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Bairro"
                                        id="solicitacao-endereco"
                                        name="Bairro"
                                        {...field}
                                        readOnly={!podeSalvar || !editavel || !unidadeConsumidora}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.Endereco ? styles.campoComValorErrado : ""}`}
                                    />
                                    {errors?.Endereco && (
                                        <HelperText text={errors?.Endereco?.message} />
                                    )}
                                </FormControl>
                            )}
                        />


                    </div>

                    <div className={styles['input-container']}>
                        <Controller
                            name="Rua"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel htmlFor="solicitacao-rua" shrink sx={{ color: "#b8b8b8" }}>Rua</InputLabel>
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Rua"
                                        id="solicitacao-rua"
                                        name="Rua"
                                        {...field}
                                        readOnly={!podeSalvar || !editavel || !unidadeConsumidora}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.Rua ? styles.campoComValorErrado : ""}`}
                                    />
                                    {errors?.Rua && (
                                        <HelperText text={errors?.Rua?.message} />
                                    )}
                                </FormControl>
                            )}
                        />

                        <Controller
                            name="NumeroEnd"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel htmlFor="solicitacao-NumeroEnd" shrink sx={{ color: "#b8b8b8" }}>Número</InputLabel>
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Número"
                                        id="solicitacao-NumeroEnd"
                                        name="NumeroEnd"
                                        {...field}
                                        readOnly={!podeSalvar || !editavel || !unidadeConsumidora}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.NumeroEnd ? styles.campoComValorErrado : ""}`}
                                    />
                                    {errors?.NumeroEnd && (
                                        <HelperText text={errors?.NumeroEnd?.message} />
                                    )}
                                </FormControl>
                            )}
                        />
                    </div>

                    <div className={styles['input-container']}>
                        <Controller
                            name="Cep"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel
                                        htmlFor="solicitacao-Cep"
                                        shrink
                                        sx={{ color: "#b8b8b8" }}
                                    >
                                        CEP
                                    </InputLabel>

                                    <InputMask
                                        mask="99999-999"
                                        onChange={onChange}
                                        value={value || ""}
                                        id="solicitacao-Cep"
                                        readOnly={!podeSalvar || !editavel || !unidadeConsumidora}
                                    >
                                        {(inputProps) => (
                                            <WhiteInput
                                                fullWidth
                                                placeholder="CEP"
                                                name="Cep"
                                                {...inputProps}
                                                onKeyDown={onKeyDown}
                                                readOnly={
                                                    !podeSalvar ||
                                                    !editavel ||
                                                    !unidadeConsumidora
                                                }
                                                className={`${errors?.Cep
                                                        ? styles.campoComValorErrado
                                                        : ""
                                                    }`}
                                            />
                                        )}
                                    </InputMask>

                                    {errors?.Cep && (
                                        <HelperText text={errors?.Cep?.message} />
                                    )}
                                </FormControl>
                            )}
                        />

                        <Controller
                            name="UF"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']} style={{ zIndex: 2 }}>
                                    <InputLabel htmlFor="solicitacao-UF" shrink sx={{ color: "#b8b8b8" }}>UF</InputLabel>
                                    <UF
                                        field={field}
                                        placeholder="Selecione um estado"
                                        id="solicitacao-UF"
                                        name="UF"
                                        {...field}
                                        disabled={!podeSalvar || !editavel || !unidadeConsumidora}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.UF ? styles.campoComValorErrado : ""}`}
                                    />
                                    {errors?.UF && (
                                        <HelperText text={errors?.UF?.message} />
                                    )}
                                </FormControl>
                            )}
                        />
                    </div>
                    <div className={styles['input-container']}>
                        <Controller
                            name="Latitude"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel htmlFor="solicitacao-Latitude" shrink sx={{ color: "#b8b8b8" }}>Latitude</InputLabel>
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Latitude"
                                        id="solicitacao-Latitude"
                                        name="Latitude" {...field}
                                        readOnly={!podeSalvar || !editavel}
                                    />
                                    {errors?.Latitude && (
                                        <HelperText text={errors?.Latitude?.message} />
                                    )}
                                </FormControl>
                            )}
                        />

                        <Controller
                            name="Longitude"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" className={styles['campos-m']}>
                                    <InputLabel htmlFor="solicitacao-Longitude" shrink sx={{ color: "#b8b8b8" }}>Longitude</InputLabel>
                                    <WhiteInput
                                        fullWidth
                                        placeholder="Longitude"
                                        id="solicitacao-Longitude"
                                        name="Longitude" {...field}
                                        readOnly={!podeSalvar || !editavel}
                                    />
                                    {errors?.Longitude && (
                                        <HelperText text={errors?.Longitude?.message} />
                                    )}
                                </FormControl>
                            )}
                        />
                    </div>

                    <div className={styles['input-container']}>
                        <Controller
                            name="Complemento"
                            control={control}
                            render={({ field }) => (
                                <FormControl variant="outlined" style={{ width: "85%" }}>
                                    <InputLabel htmlFor="solicitacao-Complemento" shrink sx={{ color: "#b8b8b8" }}>Complemento</InputLabel>
                                    <WhiteInput
                                        multiline
                                        minRows={3}
                                        fullWidth
                                        placeholder="Complemento"
                                        id="solicitacao-Complemento"
                                        name="Complemento"
                                        {...field}
                                        readOnly={!podeSalvar || !editavel || !unidadeConsumidora}
                                        onKeyDown={onKeyDown}
                                        className={`${errors?.Complemento ? styles.campoComValorErrado : ""}`}
                                    />
                                    {errors?.Complemento && (
                                        <HelperText text={errors?.Complemento?.message} />
                                    )}
                                </FormControl>
                            )}
                        />
                    </div>
                </div>
            )}
        </Container>
    )
}

export { Localizacao }